import { Beacon } from "./Beacon.js";
export class FilteredObservable extends Beacon {
    #source;
    #observer;
    subscription;
    constructor(source, predicate) {
        let emitter;
        super((_emitter) => {
            emitter = _emitter;
        });
        this.#observer = {
            next: (value) => {
                if (predicate(value)) {
                    emitter.next(value);
                }
            },
            error: (error) => {
                emitter.error(error);
            },
            complete: () => {
                emitter.complete();
            },
        };
        this.#source = source;
        this.subscription = this.#source.subscribe(this.#observer);
    }
}
